import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ThemeToggle } from "@/components/ThemeToggle";

export const AuthLayout = ({ title, subtitle, children, footer }) => (
  <div className="min-h-screen grid lg:grid-cols-2">
    <div className="hidden lg:block relative overflow-hidden grain">
      <img src="/img/hero.jpg" alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-slate-950/60" />
      <div className="relative h-full flex flex-col justify-between p-12">
        <Logo light />
        <p className="font-display text-white text-4xl font-bold leading-tight max-w-md">Mail that proves it arrived.</p>
      </div>
    </div>
    <div className="flex flex-col">
      <div className="flex items-center justify-between p-6">
        <span className="lg:hidden"><Logo /></span>
        <span className="hidden lg:block" />
        <ThemeToggle />
      </div>
      <div className="flex-1 flex items-center justify-center px-6 pb-16">
        <div className="w-full max-w-md">
          <h1 className="font-display text-3xl font-bold tracking-tight">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500 mt-2">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-8 text-sm text-slate-500">{footer}</div>}
        </div>
      </div>
    </div>
  </div>
);

export const BackHome = () => <Link to="/" className="underline hover:text-emerald-600">Back to home</Link>;
